module.exports = __webpack_public_path__ + "img/desk3.906a74a5.png";